import React, { useContext } from 'react';
import { IDishesContext, DishesContext } from '../../../dishesState/dishesContext';
import { Checkbox } from 'antd';
import Text from 'components/Text/Text';

export const IsDisabledCheckbox: React.FC = () => {
	const { toggleIsDisabled, isDisabled, IDSelectedRestaurant } = useContext<IDishesContext>(DishesContext);

	return (
		<Checkbox
			indeterminate={isDisabled === null}
			checked={!!isDisabled}
			onChange={toggleIsDisabled}
			disabled={!IDSelectedRestaurant}
			data-test="IsDisabledCheckbox">
			<Text translationNameSpace="listing" translationKey="dishInStopLabel" asFragment={true} />
		</Checkbox>
	);
};
